var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Icons from "./Icon";
import { darken, rgba } from 'polished';
import React from 'react';
import { applyCyAttribute, css, mq, styled } from "../utils";
var mapIcons = {
    success: Icons.CircleCheck,
    info: Icons.CircleInfo,
    warning: Icons.CircleWarning,
    error: Icons.CircleError,
};
var Container = styled.div(function (_a) {
    var appearance = _a.appearance, _b = _a.theme, colors = _b.colors, fontWeights = _b.fontWeights;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 1rem;\n    width: 100%;\n    object-fit: contain;\n    font-weight: ", ";\n    color: ", ";\n    background: ", ";\n    margin-bottom: 5px;\n    box-sizing: border-box;\n    display: flex;\n\n    ", ";\n  "], ["\n    padding: 1rem;\n    width: 100%;\n    object-fit: contain;\n    font-weight: ", ";\n    color: ", ";\n    background: ", ";\n    margin-bottom: 5px;\n    box-sizing: border-box;\n    display: flex;\n\n    ", ";\n  "])), fontWeights.medium, colors.primary, rgba(colors.status[appearance], 0.97), mq({
        borderRadius: [0, '5px'],
    }));
});
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 1;\n  margin-top: 5px;\n"], ["\n  flex-grow: 1;\n  margin-top: 5px;\n"])));
var IconWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 1rem;\n  width: 26px;\n  height: 26px;\n"], ["\n  margin-right: 1rem;\n  width: 26px;\n  height: 26px;\n"])));
var CloseButton = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  margin: 0.3rem 0 0 1rem;\n"], ["\n  cursor: pointer;\n  margin: 0.3rem 0 0 1rem;\n"])));
var CloseIcon = styled(Icons.Close)(function (_a) {
    var appearance = _a.appearance, colors = _a.theme.colors;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 20px;\n    height: 20px;\n    path {\n      fill: ", ";\n    }\n    &:hover {\n      path {\n        fill: ", ";\n      }\n    }\n  "], ["\n    width: 20px;\n    height: 20px;\n    path {\n      fill: ", ";\n    }\n    &:hover {\n      path {\n        fill: ", ";\n      }\n    }\n  "])), darken(0.1, colors.status[appearance]), darken(0.2, colors.status[appearance]));
});
var Toast = function (_a) {
    var children = _a.children, appearance = _a.appearance, onDismiss = _a.onDismiss;
    var Icon = mapIcons[appearance];
    return (React.createElement(Container, __assign({ appearance: appearance }, applyCyAttribute('toast')),
        React.createElement(IconWrapper, null,
            React.createElement(Icon, { className: "icon" })),
        React.createElement(Content, { className: "content" }, children),
        React.createElement(CloseButton, { className: "close", onClick: function () { return onDismiss(); } },
            React.createElement(CloseIcon, { appearance: appearance }))));
};
export default Toast;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Toast.js.map